import { render, staticRenderFns } from "./calladmin.vue?vue&type=template&id=46887662&scoped=true&"
import script from "./calladmin.vue?vue&type=script&lang=js&"
export * from "./calladmin.vue?vue&type=script&lang=js&"
import style0 from "./calladmin.vue?vue&type=style&index=0&id=46887662&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46887662",
  null
  
)

export default component.exports